// Tenant branding -> CSS custom properties + document chrome. One build,
// many brands: everything visual the DOM layer uses routes through these vars.
import type {TenantConfig} from '../scene/config'

export function applyTheme(tenant: TenantConfig): void {
  const root = document.documentElement.style
  root.setProperty('--bg', tenant.theme.bg)
  root.setProperty('--fg', tenant.theme.fg)
  root.setProperty('--accent', tenant.theme.accent)
  root.setProperty('--accent2', tenant.theme.accent2)
  document.title = tenant.name
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', tenant.theme.bg)
}
